import { get } from "jquery";
import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const masterDataService = {
  getBranches: async () => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/branches`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch branches");
    }

    const json = await response.json();
    return json.data;
  },
};
